const domain = 'console.careconnect-qa.netsmartexchange.com';
const apiDomain = 'careconnect-qa.netsmartexchange.com';

export const environment = {
  apiUrl: `https://${apiDomain}/api`,
  baseUrl: `https://${domain}`,
  ccnxUrl: `https://${apiDomain}`,
  oktaConfig: {
    clientId: `0oa1s6mv7pdxV71mA1d8`,
    issuer: `https://ntstcareconnect.okta.com`,
    redirectUri: `https://${domain}/oidc/callback`,
    postLogoutRedirectUri: `https://${domain}/loggedout`,
  },
};
